// Tab strip shared by the trip and template editors. Tabs are URL segments
// (`<basePath>/:tab`) so a reload — or a direct link — keeps the tab. Kit `.tabs`:
// icon + label + count pill, amber underline on the active tab.

import type { ReactNode } from "react";
import { useNavigate } from "react-router-dom";
import { Tab as TabButton, vars } from "@pack-it-up/ui-web";
import { LIST_TABS, isListTab, type ListTab } from "@pack-it-up/viewmodel";
import { PackingTabIcon, TodoTabIcon, NotesTabIcon } from "../app/icons.js";

// Tab ids/labels live in @pack-it-up/viewmodel (LIST_TABS), shared with mobile.
export { LIST_TABS, isListTab };
export type { ListTab };

// Kit tab glyphs (13px stroke icons): packing (suitcase), to-do (check square), notes
// (doc) — defined in `apps/web/src/app/icons.tsx` (CLAUDE.md rule 7).
const TAB_ICONS: Record<ListTab, ReactNode> = {
  packing: PackingTabIcon,
  todos: TodoTabIcon,
  notes: NotesTabIcon,
};

export const ListTabs = ({ basePath, active, counts }: { basePath: string; active: ListTab; counts: Record<ListTab, number> }): ReactNode => {
  const navigate = useNavigate();
  return (
    <div role="tablist" style={{ display: "flex", borderBottom: `1px solid ${vars.color.border}`, padding: `0 ${vars.space.lg}`, flexShrink: 0 }}>
      {(Object.keys(LIST_TABS) as ListTab[]).map((t) => (
        <TabButton key={t} active={active === t} icon={TAB_ICONS[t]} count={counts[t]} onClick={() => void navigate(`${basePath}/${t}`)}>
          {LIST_TABS[t]}
        </TabButton>
      ))}
    </div>
  );
};
